import React from "react";
import moment from "moment";

const JobSummary = ({ job }) => {
  return (
    <div className="card z-depth-0 project-summary">
      <div className="card-content grey-text text-darken-3">
        <span className="card-title">{job.jobTitle}</span>
        <p>{job.companyName}</p>
        <p className="grey-text">{moment(job.createdAt.toDate()).calendar()}</p>
      </div>
    </div>
  );
};
export default JobSummary;
